import { useEffect, useState } from 'preact/hooks';

// Menú del sistema. Mismo orden y nombres que validó la usuaria en el prototipo; las secciones que aún no
// existen quedan visibles como "próximo" para que se sepa qué viene. La reorganización por frecuencia de uso
// se evalúa después de unas semanas de uso real.
export interface Seccion { id: string; nombre: string; proximo?: string }
export interface Modulo { nombre: string; secciones: Seccion[] }

export const MODULOS: Modulo[] = [
  { nombre: 'Operación', secciones: [
    { id: 'inicio', nombre: 'Inicio' },
    { id: 'tablero', nombre: 'Tablero' },
    { id: 'todo', nombre: "To Do's" },
    { id: 'pedidos', nombre: 'Pedidos y cotizaciones' },
    { id: 'clientes', nombre: 'Clientes' },
    { id: 'productos', nombre: 'Productos y precios' },
    { id: 'inventario', nombre: 'Inventario e insumos' },
    { id: 'gastos', nombre: 'Gastos' },
    { id: 'resultados', nombre: 'Resultados' },
    { id: 'ajustes', nombre: 'Catálogos y ajustes' },
  ] },
  { nombre: 'Ventas', secciones: [
    { id: 'enlaces', nombre: 'Pedidos por enlace', proximo: 'La página donde la clienta arma su pedido y paga. Llega en la fase 1b, con Mercado Pago, Nequi y Bre-B.' },
  ] },
  { nombre: 'Marketing', secciones: [
    { id: 'campanas', nombre: 'Campañas y mensajes' },
  ] },
];
export const SECCION: Record<string, Seccion> = Object.fromEntries(MODULOS.flatMap(m => m.secciones).map(s => [s.id, s]));

// Pantallas que no están en el menú y la sección que marcan como abierta.
const INTERNAS: Record<string, string> = { pedido: 'pedidos', compartir: 'pedidos', cliente: 'clientes', campana: 'campanas', mensaje: 'campanas', producto: 'productos', precios: 'productos' };
export interface Ruta { id: string; menu: string; args: string[] }

// La sección va en la dirección (#/productos, #/pedido/PED-0001) para que recargar o volver atrás deje a la usuaria donde estaba.
const deHash = (): Ruta => {
  const [id, ...args] = location.hash.replace(/^#\/?/, '').split(/[/?]/).filter(Boolean).map(decodeURIComponent);
  if (id && SECCION[id]) return { id, menu: id, args };
  if (id && INTERNAS[id]) return { id, menu: INTERNAS[id], args };
  return { id: 'inicio', menu: 'inicio', args: [] };
};
export const hashDe = (id: string, ...args: string[]) => '#/' + [id, ...args].map(encodeURIComponent).join('/');
export type Ir = (id: string, ...args: string[]) => void;
export function useRuta(): [Ruta, Ir] {
  const [ruta, setRuta] = useState(deHash);
  useEffect(() => {
    const cambio = () => { setRuta(deHash()); window.scrollTo(0, 0); };
    addEventListener('hashchange', cambio);
    return () => removeEventListener('hashchange', cambio);
  }, []);
  return [ruta, (id: string, ...args: string[]) => { location.hash = hashDe(id, ...args).slice(1); }];
}
